module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 006.34eac2b5.jpg";